import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { backArrow } from '../../../../assets/images';

const MFAMethod= ({methodSelect, account_setting}) => {
  const history = useHistory()

  return(
    <div className='mt-2'>
      <img src={backArrow} onClick={() => { account_setting ? history.goBack() : history.push('/login')} } className='mb-3.5 cursor-pointer'/>
      <h1 className='text-xl leading-8 text-gray-900 mb-0' style={{ fontFamily: 'PT Serif', fontWeight: 700}}>Register a Verification Method</h1>
      <p className='text-base text-gray-600 mt-4 mr-20 mb-0 w-96'>
          Select a verification method to register 
      </p>
      <div className='my-6'>
        <div className='border rounded-md border-gray-200 cursor-pointer p-3 w-96 bg-gray-50 hover:bg-gray-200' 
              onClick={(e) => methodSelect(e.target, 'app')}>
          <h3 className='text-gray-700 text-base font-semibold'>Authenticator App</h3>
          <p className='text-sm text-gray-600 mb-0'>Connect an authenticator app</p>
        </div>
        <div className='border rounded-md border-gray-200 cursor-pointer p-3 w-96 bg-gray-50 hover:bg-gray-200 my-4'
              onClick={(e) => methodSelect(e.target, 'otp')}>
          <h3 className='text-gray-700 text-base font-semibold'>One Time Password Generator</h3>
          <p className='text-sm text-gray-600 mb-0'>Receive OTP on your registered e-mail</p>
        </div>
      </div>  
      <button className='bg-blue-600 text-white w-96 mb-4 py-4 rounded-md text-base mt-8 font-semibold hover:bg-blue-600 focus:outline-none' onClick={()=> { account_setting ? history.goBack() : history.push('/login')}}>
        Cancel
      </button>
    </div>
  )

}

export default MFAMethod;